import FormField from "./FormField";
import { withRedux } from "helpers";
import { useState, useEffect } from "react";

import SearchLocationInput from "./SearchLocationInput";

const BillingDetailsFields = (props) => {
  const { cart, tempAddress, setTempAddress } = props;
  const addressIsNull = cart.address === undefined || cart.address === null;
  const [googleMapsLoaded, setGoogleMapsLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAUJLVH5igj8Z7pmh3tTzhYz0A4CGd65NI&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => setGoogleMapsLoaded(true);

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const onChangeHandler = (aptSuiteNumber) => {
    props.setTempAddress({ ...tempAddress, aptSuiteNumber: aptSuiteNumber });
  };

  return (
    <div>
      {!props.omitNameAndEmail ? (
        <div>
          <FormField
            name="name"
            label="Name"
            type="text"
            value={
              props.prefillData
                ? cart.orderCustomerInfo.firstName +
                  " " +
                  cart.orderCustomerInfo.lastName
                : ""
            }
            placeholder="Jane Doe"
            required={true}
          />
          <FormField
            name="email"
            label="Email"
            type="email"
            value={props.prefillData ? cart.orderCustomerInfo.email : ""}
            placeholder="jane.doe@example.com"
            required={true}
          />
          <FormField
            name="address"
            label="Address"
            type="text"
            value={
              props.prefillData && !addressIsNull
                ? props.cart.address.streetAddress
                : ""
            }
            placeholder="185 Berry St. Suite 550"
            required={true}
          />
          <FormField
            name="city"
            label="City"
            type="text"
            value={
              props.prefillData && !addressIsNull ? props.cart.address.city : ""
            }
            placeholder="San Francisco"
            required={true}
          />
          <FormField
            name="state"
            label="State"
            type="text"
            value={
              props.prefillData && !addressIsNull
                ? props.cart.address.state
                : ""
            }
            placeholder="CA"
            required={true}
          />
          <FormField
            name="zip"
            label="ZIP"
            type="text"
            value={
              props.prefillData && !addressIsNull ? props.cart.address.zip : ""
            }
            placeholder="94103"
            required={true}
          />
        </div>
      ) : (
        <div>
          {googleMapsLoaded && ( // Conditionally render SearchLocationInput
            <div>
              <SearchLocationInput
                setTempAddress={setTempAddress}
                tempAddress={tempAddress}
              />
              <FormField
                name="aptNumber"
                label=""
                type="text"
                value={""}
                required={false}
                placeholder="Apt/Suite Number"
                hideLabel={true}
                onChangeCustom={onChangeHandler}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default withRedux(BillingDetailsFields);